<div class="settings__query-container">
  <div class="settings__query">
    <dcc-settings-top-bar
      [company]="searchWithinCompany"
      (entitySelect)="onEntitySelected($event)"
      (settingsSearch)="onSettingSelected($event)"></dcc-settings-top-bar>
  </div>
</div>

<div>
  <p
    class="settings__toggle"
    routerLink="../current"
    routerLinkActive="selected">
    Settings
  </p>
  <p
    class="settings__toggle"
    routerLink="../history"
    routerLinkActive="selected">
    History
  </p>
</div>

<div class="settings__grid">
  <div class="settings__grid__top">
    <div class="settings__grid__top__left">
      <settings-breadcrumbs
        [highlightedEntityId]="highlightedEntityId"
        [selectedEntity]="selectedEntity"
        (breadcrumbSelect)="onEntitySelected($event)"
        (searchWithin)="searchWithin($event)"></settings-breadcrumbs>
      <button
        class="lx-btn-small lx-btn-primary"
        type="button"
        [disabled]="!editable"
        (click)="openCreationModal()">
        Modify Settings
      </button>
    </div>
    <div
      class="settings__grid__top__right"
      (click)="loadData()">
      <img src="../../../assets/images/settings/reset.svg" />
      Refresh
    </div>
  </div>

  <settings-grid
    *ngIf="settingsView === 'current'"
    [editable]="editable"
    [searchedSetting]="searchedSetting"
    [settings]="selectedEntitySettings"
    (settingClicked)="onSettingClicked($event)"
    (settingDehover)="onSettingDehover()"
    (settingHover)="onSettingHover($event)"
    (settingsReady)="loadSearchedSetting()"></settings-grid>
  <settings-history
    *ngIf="settingsView === 'history'"
    [searchedSetting]="searchedSetting"
    [settingsHistory]="selectedEntitySettingsHistory"
    (settingDehover)="onSettingDehover()"
    (settingHover)="onSettingHover(selectedEntity.id)"
    (settingsReady)="loadSearchedSetting()"></settings-history>
</div>
